// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as LotTags$LiveRoom from "../../components/LotTags.bs.js";
import * as Utils_Lot$LiveRoom from "../../Utils/Utils_Lot.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

function LotInfo(props) {
  var subtitle = props.subtitle;
  var title = props.title;
  var creators = props.creators;
  var lotNumber = props.lotNumber;
  var lotNr = typeof lotNumber === "object" && lotNumber.NAME === "VisibleLotNumber" ? lotNumber.VAL.lotNumber + "." : "";
  var creators$1 = creators !== undefined && Caml_obj.notequal(creators, []) && props.useCreatorSplit ? creators.join(" | ") : undefined;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.marginTop(Css.px(48)),
                    tl: {
                      hd: Css.marginBottom(Css.px(64)),
                      tl: {
                        hd: Css.whiteSpace("preWrap"),
                        tl: {
                          hd: Css.wordBreak(Css.breakAll),
                          tl: /* [] */0
                        }
                      }
                    }
                  })
            }, creators$1 !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(PropSpread$LiveRoom.make, {
                        data: {
                          hd: {
                            TAG: /* TestId */1,
                            _0: "lotNumberAndCreatorsTitle"
                          },
                          tl: /* [] */0
                        },
                        children: React.createElement(SterlingTypography$LiveRoom.Headline28Regular.make, {
                              className: Curry._1(Css.style, {
                                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                    tl: {
                                      hd: Css.unsafe("word-break", "break-word"),
                                      tl: /* [] */0
                                    }
                                  }),
                              children: "" + lotNr + " " + creators$1 + ""
                            })
                      }), React.createElement(PropSpread$LiveRoom.make, {
                        data: {
                          hd: {
                            TAG: /* TestId */1,
                            _0: "lotTitle"
                          },
                          tl: /* [] */0
                        },
                        children: React.createElement(SterlingTypography$LiveRoom.Paragraph18Regular.make, {
                              className: Curry._1(Css.style, {
                                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                    tl: {
                                      hd: Css.marginTop(Css.px(8)),
                                      tl: {
                                        hd: Css.marginBottom(Css.px(8)),
                                        tl: {
                                          hd: Css.unsafe("word-break", "break-word"),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }),
                              children: title
                            })
                      })) : (
                subtitle !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(PropSpread$LiveRoom.make, {
                            data: {
                              hd: {
                                TAG: /* TestId */1,
                                _0: "lotNumberAndTitle"
                              },
                              tl: /* [] */0
                            },
                            children: React.createElement(SterlingTypography$LiveRoom.Headline28Regular.make, {
                                  className: Curry._1(Css.style, {
                                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                        tl: {
                                          hd: Css.unsafe("word-break", "break-word"),
                                          tl: /* [] */0
                                        }
                                      }),
                                  children: "" + lotNr + " " + title + ""
                                })
                          }), React.createElement(PropSpread$LiveRoom.make, {
                            data: {
                              hd: {
                                TAG: /* TestId */1,
                                _0: "lotSubTitle"
                              },
                              tl: /* [] */0
                            },
                            children: React.createElement(SterlingTypography$LiveRoom.Paragraph18Regular.make, {
                                  className: Curry._1(Css.style, {
                                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                        tl: {
                                          hd: Css.marginTop(Css.px(8)),
                                          tl: {
                                            hd: Css.marginBottom(Css.px(8)),
                                            tl: {
                                              hd: Css.unsafe("word-break", "break-word"),
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }),
                                  children: subtitle
                                })
                          })) : React.createElement(PropSpread$LiveRoom.make, {
                        data: {
                          hd: {
                            TAG: /* TestId */1,
                            _0: "lotNrAndTitle"
                          },
                          tl: /* [] */0
                        },
                        children: React.createElement(SterlingTypography$LiveRoom.Headline28Regular.make, {
                              className: Curry._1(Css.style, {
                                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                    tl: {
                                      hd: Css.marginBottom(Css.px(8)),
                                      tl: {
                                        hd: Css.unsafe("word-break", "break-word"),
                                        tl: /* [] */0
                                      }
                                    }
                                  }),
                              children: "" + lotNr + " " + title + ""
                            })
                      })
              ), React.createElement(LotTags$LiveRoom.make, {
                  tags: Utils_Lot$LiveRoom.getTags(Belt_Option.getWithDefault(props.lotTags, []), Belt_Option.map(props.parcel, (function (p) {
                              return p.parcelName;
                            })))
                }));
}

var make = LotInfo;

export {
  make ,
}
/* Css Not a pure module */
